<div class="footer" [innerHTML]="footerContent$ | async"></div>